import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#fff',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1837.24 400"
    >
      <path
        className={classes.path}
        d="M273.42,209.43c-12.57,12.57-25.14,25.14-37.71,37.71-15.71,15.71-31.43,31.43-47.14,47.14,15.71,15.71,31.43,31.43,47.14,47.14,15.71-15.71,31.43-31.43,47.14-47.14,4.5-4.5,9.01-9.01,13.51-13.51,10-10,15.62-23.57,15.62-37.71v-86.11c0-14.15-5.62-27.71-15.62-37.71-4.5-4.5-9.01-9.01-13.51-13.51-15.71-15.71-31.43-31.43-47.14-47.14-15.71,15.71-31.43,31.43-47.14,47.14,15.71,15.71,31.43,31.43,47.14,47.14,12.57,12.57,25.14,25.14,37.71,37.71,5.21,5.21,5.21,13.65,0,18.86Z"
      />
      <path
        className={classes.path}
        d="M94.28,105.72c25.01,25.01,39.05,58.92,39.05,94.28s-14.05,69.28-39.05,94.28l47.14,47.14c37.51-37.51,58.58-88.38,58.58-141.42s-21.07-103.91-58.58-141.42c-15.71,15.71-31.43,31.43-47.14,47.14Z"
      />
      <path
        className={classes.path}
        d="M1294.05,248.62c-27.36,0-46.17-21.09-46.17-48.45s18.24-49.02,46.17-49.02c20.52,0,34.2,9.69,39.9,29.18h41.61c-6.27-46.28-39.9-66.23-81.51-66.23-59.28,0-89.49,41.61-89.49,86.07,0,50.16,36.48,86.07,89.49,86.07,40.47,0,75.24-19.38,81.51-66.57h-41.61c-5.7,19.26-18.81,28.95-39.9,28.95Z"
      />
      <polygon
        className={classes.path}
        points="1702.15 280.77 1666.24 228.83 1629.77 280.77 1580.18 280.77 1638.88 200 1580.18 119.23 1629.77 119.23 1666.24 172.32 1702.15 119.23 1751.74 119.23 1693.6 200 1751.74 280.77 1702.15 280.77"
      />
      <rect
        className={classes.path}
        x="1149.84"
        y="119.23"
        width="43.32"
        height="161.54"
      />
      <polygon
        className={classes.path}
        points="993.67 119.23 946.36 119.23 905.32 185.92 864.29 119.23 816.98 119.23 883.66 225.25 883.66 280.77 926.98 280.77 926.98 225.82 993.67 119.23"
      />
      <polygon
        className={classes.path}
        points="810.71 119.23 767.39 119.23 767.39 182.03 693.29 182.03 693.29 119.23 649.97 119.23 649.97 280.77 693.29 280.77 693.29 217.97 767.39 217.97 767.39 280.77 810.71 280.77 810.71 119.23"
      />
      <path
        className={classes.path}
        d="M567.9,204.16h-41.04v-49.02h41.04c15.39,0,27.36,6.84,27.36,24.51,0,18.81-13.68,24.51-27.36,24.51ZM571.32,119.24h-87.78v161.53h43.33v-40.7h44.46c41.61,0,67.26-17.67,67.26-60.42s-25.65-60.42-67.26-60.42Z"
      />
      <path
        className={classes.path}
        d="M1537.43,234.94c0-31.35-19.38-41.61-53.58-47.88-11.4-2.09-22.8-4.18-34.2-6.27-14.25-2.85-21.09-7.98-21.09-16.53,0-11.4,10.26-17.67,31.35-17.67s32.49,7.41,34.77,22.23h38.76c0-39.33-31.35-54.72-73.53-54.72s-72.96,14.25-72.96,49.59c0,21.66,12.54,41.04,42.75,46.74,13.49,2.66,26.98,5.32,40.47,7.98,11.4,2.28,24.51,5.13,24.51,16.53,0,11.97-11.4,18.24-34.77,18.24s-37.62-7.98-38.76-23.37h-39.33c0,40.47,33.06,56.43,76.95,56.43,40.47,0,78.66-10.83,78.66-51.3Z"
      />
      <path
        className={classes.path}
        d="M1137.87,234.94c0-31.35-19.38-41.61-53.58-47.88-11.4-2.09-22.8-4.18-34.2-6.27-14.25-2.85-21.09-7.98-21.09-16.53,0-11.4,10.26-17.67,31.35-17.67s32.49,7.41,34.77,22.23h38.76c0-39.33-31.35-54.72-73.53-54.72s-72.96,14.25-72.96,49.59c0,21.66,12.54,41.04,42.75,46.74,13.49,2.66,26.98,5.32,40.47,7.98,11.4,2.28,24.51,5.13,24.51,16.53,0,11.97-11.4,18.24-34.77,18.24s-37.62-7.98-38.76-23.37h-39.33c0,40.47,33.06,56.43,76.95,56.43,40.47,0,78.66-10.83,78.66-51.3Z"
      />
    </svg>
  );
};

export default LogoFull;
